<template>
  <div class="mx-3 my-3 pb-4">
    <div class="grid grid-cols-12 gap-4">
      <div class="flex flex-col col-span-12 md:col-span-2" style="cursor: pointer;">
        <div
          :class="currentRoute === 'form-codes' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('form-codes')"
        >
          <div class="flex">
            <div>Form Codes</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'mappings' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('mappings')"
        >
          <div class="flex">
            <div>Mappings</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 md:col-span-10">
        <ObrsFormCodes v-if="currentRoute === 'form-codes'" ref="formCodesRef" />
        <ObrsTypeMappings v-if="currentRoute === 'mappings'" ref="mappingsRef" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from "vue";
import ObrsFormCodes from "./ObrsFormCodes.vue";
import ObrsTypeMappings from "./ObrsTypeMappings.vue";

type TabChild = { refresh?: () => void } | null;

const currentRoute = ref("form-codes");
const formCodesRef = ref<TabChild>(null);
const mappingsRef = ref<TabChild>(null);

const refreshActiveTab = () => {
  if (currentRoute.value === "form-codes") formCodesRef.value?.refresh?.();
  else if (currentRoute.value === "mappings") mappingsRef.value?.refresh?.();
};

const select = (route: string) => {
  currentRoute.value = route;
  nextTick(() => refreshActiveTab());
};

defineExpose({ refresh: refreshActiveTab });
</script>
